export const roleName = (role) => role.is_system_role && role.name === 'Guestbook Editor'
  ? 'Guest Guide Editor' : role.name;

// Match API ownership; the legacy primary-recipient label does not grant access.
export const isRecipientOwner = (recipient) => {
  const user = recipient.users?.find((entry) =>
    entry?.user_id != null && String(entry.user_id) === String(recipient.user_id));
  return Boolean(user && (user.owner_id === 0 || user.owner_id === '0'));
};

export const roleDescription = (role) => {
  if (!role.is_system_role) return role.description;
  if (role.name === 'Admin') return 'Full access to all sections except billing. Only the owner can remove users or appoint administrators.';
  if (['Operations', 'Housekeeping', 'Maintenance'].includes(role.name)) return 'View and update assigned housekeeping and maintenance tasks through My Tasks. No access to other staff’s tasks.';
  if (role.name === 'CRM Manager') return 'Manage leads, contacts, pipelines, activities, and notes; view and update assigned tasks.';
  if (role.name === 'Operations Manager') return 'Manage all work orders, calendar, checklists, inventory, property standards, and work schedules.';
  if (role.name === 'Guest Services') return 'Manage messaging, guests, contacts, surveys, and AI Assistant.';
  return role.description;
};

export const taskScopeLabel = (permissions = []) => {
  const levels = Object.fromEntries(permissions.map((p) => [p.module_key, p.access_level]));
  if (levels['operations.work_orders'] === 'edit') return 'Manage all work orders';
  if (levels['operations.work_orders'] === 'view') return levels['operations.tasks'] === 'edit'
    ? 'View all work orders; update assigned tasks' : 'View all work orders';
  if (levels['operations.tasks'] === 'edit') return 'View and update assigned tasks only';
  if (levels['operations.tasks'] === 'view') return 'View assigned tasks only';
  return 'No task access';
};
